import { render, staticRenderFns } from "./CropperImage.vue?vue&type=template&id=4b1666f2&scoped=true"
import script from "./CropperImage.vue?vue&type=script&lang=js"
export * from "./CropperImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1666f2",
  null
  
)

export default component.exports